export default {
    name: 'DGORow',
    componentName: 'DGORow',
    props: {
        baseClass: {
            type: String,
            default: 'dgo-row'
        },
        tag: { 
            type: String,
            default: 'div',
        },
        cols: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ((Number.isInteger(Number(value[item])) && Number(value[item]) > 0 && Number(value[item]) < 25 )
                        || ['auto', 'none'].includes(value[item])) : total, true),
        },
        wrap: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['wrap', 'nowrap'].includes(value[item]) : total, true),
        },
        direction: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['row', 'column'].includes(value[item]) : total, true),
        },
        justify: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['flex-start', 'flex-end', 'center', 'space-around', 'space-between']
                        .includes(value[item]) : total, true),
        },
        align: {
            type: Object,
            default() { return {}; },
            validator: (value)=> Object.keys(value).reduce((total, item)=>
                total ? ['xs', 'sm', 'md', 'lg', 'xl'].includes(item)
                    && ['flex-start', 'flex-end', 'center', 'stretch'].includes(value[item]) : total, true),
        },
    },
    computed: {
        gutter() {
            let parent = this.$parent;
            while (parent && parent.$options.componentName !== 'DGOContainer') { parent = parent.$parent; }
            return parent ? Number(parent.gutter) : 0;
        },
        colsClass() {
            if (Object.keys(this.cols).length) {
                return Object.keys(this.cols).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--cols-${this.cols[item]}`
                        : `${this.baseClass}--${item}-cols-${this.cols[item]}`)
            }

            return [];
        },
        wrapsClass() {
            if (Object.keys(this.wrap).length) {
                return Object.keys(this.wrap).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--${this.wrap[item]}`
                        : `${this.baseClass}--${item}-${this.wrap[item]}`)
            }

            return [];
        },
        directionClass() {
            if (Object.keys(this.direction).length) {
                return Object.keys(this.direction).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--${this.direction[item]}`
                        : `${this.baseClass}--${item}-${this.direction[item]}`)
            }

            return [];
        },
        justifyClass() {
            if (Object.keys(this.justify).length) {
                return Object.keys(this.justify).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--justify-${this.justify[item]}`
                        : `${this.baseClass}--${item}-justify-${this.justify[item]}`)
            }

            return [];
        },
        alignClass() {
            if (Object.keys(this.align).length) {
                return Object.keys(this.align).map(item =>
                    item === 'xs'
                        ? `${this.baseClass}--align-${this.align[item]}`
                        : `${this.baseClass}--${item}-align-${this.align[item]}`)
            }

            return [];
        },
    },
    data() {
        return {};
    },
}
